/**
 * @fileoverview GET handler for the "/engagement/android_notification_channels" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAndroidNotificationChannels } from "./constants";
import type { GetAndroidNotificationChannelsResult } from "./types";

export const getAndroidNotificationChannels = reactQueryFetcherAdapter(
  engagementAndroidNotificationChannels,
  (signal: AbortSignal): Promise<GetAndroidNotificationChannelsResult> => {
    return fetch(`/engagement/android_notification_channels`, "GET", undefined, { signal });
  }
);
